module.exports = __webpack_public_path__ + "img/dinner_title--extra.b20939be.png";